import * as Sentry from '@sentry/angular';

import { SentryEnvironmentConfig } from
    '@app/secure/interface/SentryEnvironmentConfig.interface';

/**
 * @desc Boots the Sentry Angular SDK from environment config.
 */
class SentryBootstrap
{
    /**
     * @desc Initialize Sentry when a DSN is configured; no-op otherwise.
     * @access public
     * @param environment : app environment with DSN and labels
     * @return -
     */
    public static init
    (
        environment: SentryEnvironmentConfig
    ): void
    {
        let dsn: string;
        let tracesSampleRate: number;
        let apiHost: string;
        let authHost: string;
        let targets: Array<string | RegExp>;

        dsn = (environment.sentryDsn || '').trim();

        if (dsn)
        {
            tracesSampleRate = environment.production ? 0.1 : 1.0;
            apiHost = SentryBootstrap.hostFromUrl(environment.apiUrl);
            authHost = SentryBootstrap.hostFromUrl(
                environment.authUrl || '');
            targets = ['localhost'];

            if (apiHost)
            {
                targets.push(apiHost);
            }

            if (authHost && authHost !== apiHost)
            {
                targets.push(authHost);
            }

            targets.push(/^https:\/\/.*\.cyphersystem\.com/);

            Sentry.init
            ({
                dsn: dsn,
                environment: environment.sentryEnvironment,
                release: 'cypherWebApp@' + environment.VERSION,
                integrations:
                [
                    Sentry.browserTracingIntegration()
                ],
                tracesSampleRate: tracesSampleRate,
                tracePropagationTargets: targets
            });
        }
    }

    /**
     * @desc Extract hostname from an absolute URL, or empty string.
     * @access private
     * @param url : absolute or empty URL
     * @return hostname or ''
     */
    private static hostFromUrl
    (
        url: string
    ): string
    {
        let result: string;
        let parsed: URL | null;

        result = '';
        parsed = null;

        if (url)
        {
            try
            {
                parsed = new URL(url);
                result = parsed.hostname || '';
            }
            catch (error: unknown)
            {
                result = '';
            }
        }

        return result;
    }
}

export default SentryBootstrap;
